module.exports = __webpack_public_path__ + "f217acdf68719b4fe3b8d9c039402ee7.ttf";